import {
  FormControl,
  InputLabel,
  MenuItem,
  Select as SelectMaterial,
} from "@mui/material";


const Select = ({ label, value, list, onChange }) => {
  return (
    <FormControl fullWidth >
      <InputLabel id="select-label">{label}</InputLabel>
      <SelectMaterial labelId="select-label" value={value} onChange={onChange}>
        {list.map((item) => (
          <MenuItem key={item.value} value={item.value}>
            {item.description}
          </MenuItem>
        ))}
      </SelectMaterial>
    </FormControl>
  );
};

export default Select;
